import React from "react";

import { Provider, ReactReduxContext } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConnectedRouter } from "connected-react-router";
import { HashRouter, Route, Switch } from "react-router-dom";

import configureStore, { history } from "./store";
import App from "./containers/App";

import "util/iconsFontawesome.js";

export const { store, persistor } = configureStore();

export default function MainApp() {

    return (
        <Provider store={store} context={ReactReduxContext}>
            <PersistGate persistor={persistor}>
                <ConnectedRouter history={history}>
                    <HashRouter>
                        <Switch>
                            <Route path="/" component={App} />
                        </Switch>
                    </HashRouter>
                </ConnectedRouter>
            </PersistGate>
        </Provider>
    );
}
